import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Api from 'api';
import * as Actions from 'actions';
import * as Permissions from 'permissions';
import { Alert } from 'react-bootstrap';

import {FormBuilder} from '../../';
class FieldSettings extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'FieldSettings';
    this.handleSelectGroup = this.handleSelectGroup.bind(this);
    this.handleCreateField = this.handleCreateField.bind(this);
    this.handleUpdateField = this.handleUpdateField.bind(this);
    this.handleDeleteField = this.handleDeleteField.bind(this);
    this.handleUpdateGroupOrder = this.handleUpdateGroupOrder.bind(this);

    this.state = {
      group : 'Client',
      options : [ 'Client', 'Job' ],
      order: [],
    }
  }
  componentDidMount() {
    this.props.fetchFields(this.state.group);
    Api
      .fetchFieldGroupOrder(this.state.group)
      .then(order => this.setState({order : order || []}))
      .catch(this.props.notify);
  }
  handleSelectGroup(group) {
    this.setState({ group });
    this.props.fetchFields(group);
    Api
      .fetchFieldGroupOrder(this.state.group)
      .then(order => this.setState({order : order || []}))
      .catch(this.props.notify);
  }
  handleCreateField(field) {
    //Make the field a client field.
    field.entity = this.state.group;
    this.props.createField(field);
  }
  handleUpdateField(field) {
    this.props.updateField(field)
  }
  handleDeleteField(field) {
    this.props.deleteField(field)
  }
  handleUpdateGroupOrder(newOrder) {
    Api
      .setFieldGroupOrder(this.state.group, newOrder)
      .then(order => this.setState({ order }))
      .catch(this.props.notify);
  }
  render() {
    if(!this.props.hasPermission(Permissions.UPDATE_FIELD_SETTINGS)) {
      return <Alert bsStyle='warning'>
        <h4>Sorry! Insufficient Permissions.</h4>
        <p>You must have gotten here in error, because you do not have permission to change these settings.</p>
        <p>Contact your administrator if this makes no sense.</p>
      </Alert>
    }

    return(
      <div className="panel panel-transparent">
        <div className="panel-heading">
          <div className="input-group">
          <div className="input-group-addon"><i className="fa fa-cogs"></i> Entity </div>
          <select className="form-control" value={this.state.group} onChange={e => this.handleSelectGroup(e.target.value)}>
            {this.state.options.map((option, i) => <option key={i} value={option}>{option}</option>)}
          </select>
          </div>
        </div>
        <div className="panel-body">
          {this.props.fetching_fields ? (
            <div className="alert alert-info"><i className="fa fa-spinner fa-spin fa-2x"></i> Fetching {this.state.group} Custom Fields.</div>
          ) : (
           <FormBuilder
              type={this.state.group}
              groupOrder={this.state.order}
              editAdminFields={this.props.canEditPermanentFields}
              onCreateField={this.handleCreateField.bind(this)}
              onUpdateField={this.handleUpdateField.bind(this)}
              onDeleteField={this.handleDeleteField.bind(this)}
              onChangeField={this.handleUpdateField.bind(this)}
              onUpdateGroupOrder={this.handleUpdateGroupOrder.bind(this)}
              fields={(this.props[this.state.group] || []).sort((a,b) => (a.order || 0) - (b.order || 0))}
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({fields, connection}) => ({
  ...fields,
  canEditPermanentFields: connection.user.is_admin
});

export default connect(mapStateToProps, Actions)(FieldSettings);



// WEBPACK FOOTER //
// ./src/browser/components/clients/settings/field-settings.js